<div class="flex flex-col justify-start overflow-hidden flex-auto w-full">

    <!-- Header -->
    <div class="accordion w-full md:hidden">
        <div class="accordion-item">
            <div class="accordion-header text-primary-900" (click)="toggleAccordion(2)">{{roData.ro_name}} - {{
                currentreport.name }}</div>
            <div class="accordion-content" id="section2">
                <div
                    class="flex flex-col sm:flex-row items-start sm:items-center sm:justify-between p-2 pl-4 border-b bg-card dark:bg-transparent">
                    <!-- Title -->
                    <div>
                        <!-- <div class="text-4xl font-extrabold tracking-tight leading-none"></div>
            <div class="flex items-center mt-0.5 font-medium text-secondary">
               
            </div> -->
                        <div class="flex flex-row justify-evenly gap-4 items-center">
                            <div class="flex md:flex-row flex-col jusfify-start items-center">
                                <div *ngIf="show ==='Individual'">
                                    <mat-form-field class="flex-auto md:w-100 w-80 md:mr-4"
                                        *ngIf="userrole && (userrole == 'ClientAdmin' || userrole == 'SuperAdmin' || userrole == 'ServerAdmin' || userrole == 'Viewer')"
                                        id="rocode">
                                        <mat-label>Retail Outlet</mat-label>
                                        <mat-select placeholder="RO Name" name="rocode" id="rocode" [(ngModel)]="roData"
                                            (ngModelChange)="changero($event, roData)">
                                            <mat-select-trigger>
                                                {{roData.ro_name}}
                                            </mat-select-trigger>
                                            <mat-select-filter [array]="codeh" [displayMember]="'ro_name'"
                                                (filteredReturn)="rolist =$event"></mat-select-filter>
                                            <mat-option *ngFor="let ro of rolist" [value]="ro">
                                                {{ro.ro_name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <mat-form-field class="flex-auto w-80 md:w-100" id="report">
                                    <mat-label>Report</mat-label>
                                    <mat-select placeholder="Report" name="report" id="report"
                                        [(ngModel)]="currentreport" (ngModelChange)="changerepo($event, currentreport)">
                                        <mat-select-trigger>
                                            {{currentreport.name}}
                                        </mat-select-trigger>
                                        <mat-select-filter [array]="codei" [displayMember]="'name'"
                                            (filteredReturn)="reportslist =$event"></mat-select-filter>
                                        <mat-option *ngFor="let repo of reportslist" [value]="repo">
                                            {{repo.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="md:flex hidden">
                                <button (click)="downloadDivAsPdf()"
                                    *ngIf="currentreport && (currentreport.name === 'Field Officer Inspection Report' || currentreport.name === 'Daily Sales Report' || currentreport.name === 'Tank & Nozzle Sales Comparison')"
                                    mat-flat-button [color]="'primary'">
                                    <mat-icon [svgIcon]="'download'"></mat-icon>
                                    <span class="ml-2 mr-1">Download</span>
                                </button>
                            </div>
                            <div class="md:hidden block pr-3">
                                <button (click)="downloadDivAsPdf()"
                                    *ngIf="currentreport && (currentreport.name === 'Field Officer Inspection Report' || currentreport.name === 'Daily Sales Report' || currentreport.name === 'Tank & Nozzle Sales Comparison')"
                                    [color]="'primary'">
                                    <mat-icon [svgIcon]="'download'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- Actions -->
                    <!-- <div class="mt-4 sm:mt-0">
            <button
                mat-flat-button
                [color]="'primary'">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1">Upload file</span>
            </button>
        </div> -->
                </div>
            </div>
        </div>
    </div>
    <div
        class="hidden md:flex flex-col sm:flex-row items-start sm:items-center sm:justify-between p-2 pl-4 border-b bg-card dark:bg-transparent">
        <!-- Title -->
        <div>
            <!-- <div class="text-4xl font-extrabold tracking-tight leading-none"></div>
            <div class="flex items-center mt-0.5 font-medium text-secondary">
               
            </div> -->
            <div class="flex flex-row justify-evenly gap-4 items-center">
                <div class="flex md:flex-row flex-col jusfify-start items-center">
                    <div *ngIf="show ==='Individual'">
                        <mat-form-field class="flex-auto md:w-100 w-80 md:mr-4"
                            *ngIf="userrole && (userrole == 'ClientAdmin' || userrole == 'SuperAdmin' || userrole == 'ServerAdmin' || userrole == 'Viewer')"
                            id="rocode">
                            <mat-label>Retail Outlet</mat-label>
                            <mat-select placeholder="RO Name" name="rocode" class="p-2" [(ngModel)]="roData"
                                (ngModelChange)="changero($event, roData)">
                                <mat-select-trigger>
                                    {{roData.ro_name}}
                                </mat-select-trigger>
                                <mat-select-filter [array]="codeh" [displayMember]="'ro_name'"
                                    (filteredReturn)="rolist =$event"></mat-select-filter>
                                <mat-option *ngFor="let ro of rolist" [value]="ro">
                                    {{ro.ro_name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <mat-form-field class="flex-auto w-80 md:w-100" id="report">
                        <mat-label>Report</mat-label>
                        <mat-select placeholder="Report" name="report" class="p-2" [(ngModel)]="currentreport"
                            (ngModelChange)="changerepo($event, currentreport)">
                            <mat-select-trigger>
                                {{currentreport.name}}
                            </mat-select-trigger>
                            <mat-select-filter [array]="codei" [displayMember]="'name'"
                                (filteredReturn)="reportslist =$event"></mat-select-filter>
                            <mat-option *ngFor="let repo of reportslist" [value]="repo">
                                {{repo.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="md:flex hidden">
                    <button (click)="downloadDivAsPdf()"
                        *ngIf="currentreport && (currentreport.name === 'Field Officer Inspection Report' || currentreport.name === 'Daily Sales Report' || currentreport.name === 'Tank & Nozzle Sales Comparison')"
                        mat-flat-button [color]="'primary'" id="download">
                        <mat-icon [svgIcon]="'download'"></mat-icon>
                        <span class="ml-2 mr-1">Download</span>
                    </button>
                </div>
                <div class="md:hidden block pr-3">
                    <button (click)="downloadDivAsPdf()"
                        *ngIf="currentreport && (currentreport.name === 'Field Officer Inspection Report' || currentreport.name === 'Daily Sales Report' || currentreport.name === 'Tank & Nozzle Sales Comparison')"
                        [color]="'primary'">
                        <mat-icon [svgIcon]="'download'"></mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <!-- Actions -->
        <!-- <div class="mt-4 sm:mt-0">
            <button
                mat-flat-button
                [color]="'primary'">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1">Upload file</span>
            </button>
        </div> -->
    </div>
    <div class="pb-6">
        <div class="overflow-scroll flex flex-wrap"
            *ngIf="load && currentreport && currentreport.name !== 'Field Officer Inspection Report' && currentreport.name !== 'Daily Sales Report' && currentreport.name !== 'Tank & Nozzle Sales Comparison'">
            <iframe width="100%" title="description" class="reportsheight" [src]="urlSafe1"></iframe>
        </div>
        <div class="bg-white"
            *ngIf="load && currentreport && currentreport.name === 'Field Officer Inspection Report'  && show ==='Individual'">
            <app-foir-report id="downloadReportsfoir" [rocode]="roData.ro_code" [roname]="roData.ro_name"></app-foir-report>
        </div>
        <div class="bg-white"
        *ngIf="load && currentreport && currentreport.name === 'Tank & Nozzle Sales Comparison'  && show ==='Individual'">
        <app-tank-nozzle-sales id="downloadReportsfoirtank" [rocode]="roData.ro_code"></app-tank-nozzle-sales>
    </div>
        <div #downloadReportsdsr id="downloadReportsdsr"
            class="bg-white downloadReportsdsr overflow-scroll justify-center  flex flex-wrap"
            *ngIf="load && currentreport && currentreport.name === 'Daily Sales Report'  && show ==='Individual'">
            <app-dsr-report id="downloadReportsdsr"  class="reportsheight w-[100%]" [hidego]= "isChildHidden" [rocode]="roData.ro_code" [roname]="roData.ro_name"></app-dsr-report>
        </div>
    </div>
</div>

<div class="loader-class bg-primary-300 bg-opacity-25 custom-class" *ngIf="loadingreports">
    <img src="assets/images/loading.gif" class="w-[30px] h-[30px] flex flex-col align-center justify-center" alt="image"
        width="5px" height="5px" alt="">
</div>